export const POOL_CONDITIONS = [
	"blue",
	"dry",
	"false pool",
	"unknown",
	"green",
	"murky",
	"covered",
	"partial",
] as const;

export type PoolCondition = (typeof POOL_CONDITIONS)[number];

export const POOL_CONDITION_COLORS: Record<PoolCondition, string> = {
	blue: "#0d6efd",
	dry: "#8b4513",
	"false pool": "#dc3545",
	unknown: "#0dcaf0",
	green: "#198754",
	murky: "#6c757d",
	covered: "#6f42c1",
	partial: "#ffc107",
};

export const POOL_CONDITION_LABELS: Record<PoolCondition, string> = {
	blue: "Blue",
	dry: "Dry",
	"false pool": "False pool",
	unknown: "Unknown",
	green: "Green",
	murky: "Murky",
	covered: "Covered",
	partial: "Partial",
};

export const POOL_TYPES = ["standard", "above-ground"] as const;

export type PoolType = (typeof POOL_TYPES)[number];

export const POOL_TYPE_LABELS: Record<PoolType, string> = {
	standard: "Standard (in-ground)",
	"above-ground": "Above-ground (temporary)",
};

/** Human-readable label for a pool type, falling back to the raw value. */
export function poolTypeLabel(t: string): string {
	return POOL_TYPE_LABELS[t as PoolType] ?? t;
}

export type DetectionSource =
	| "high-res-model"
	| "medium-res-model"
	| "ground-truth"
	| "human-override";

export const DETECTION_SOURCE_LABELS: Record<DetectionSource, string> = {
	"high-res-model": "High-res model",
	"medium-res-model": "Medium-res model",
	"ground-truth": "Ground truth",
	"human-override": "Human override",
};

export interface DetectionEvent {
	date: string;
	condition: PoolCondition;
	source?: DetectionSource;
}

export interface ExportMarker {
	date: string;
	format: string;
}

export interface MockPool {
	id: string;
	address: string;
	condition: PoolCondition;
	latitude: number;
	longitude: number;
	ownerName: string;
	parcelAPN: string;
	geometry: any | null;
	situs: SitusData | null;
	parcelExtId: string;
	detections: DetectionEvent[];
	exports: ExportMarker[];
}

export interface SitusData {
	address_raw?: string | null;
	lot_size_sqft?: number | null;
	lot_size_acres?: number | null;
	year_built?: number | null;
	bedrooms?: number | null;
	full_baths?: number | null;
	half_baths?: number | null;
	building_sqft?: number | null;
	num_units?: number | null;
	property_type?: string | null;
	net_assessed_value?: number | null;
	land_value?: number | null;
	fireplace_count?: number | null;
	pool_count?: number | null;
	tax_rate_area?: string | null;
	raw_data?: Record<string, string> | null;
}
